import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "128",
  height: "128",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#03B146",
      d: "M31.5 24c-4.14 0-7.5 3.36-7.5 7.5V39h-7.5a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5h40c1.375 0 2.5 1.125 2.5 2.5S57.875 49 56.5 49h-35a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5h30c1.375 0 2.5 1.125 2.5 2.5S52.875 59 51.5 59h-35a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5h30c1.375 0 2.5 1.125 2.5 2.5S47.875 69 46.5 69H24v20c0 8.281 6.719 15 15 15s15-6.719 15-15h20c0 8.281 6.719 15 15 15s15-6.719 15-15h5c2.766 0 5-2.234 5-5s-2.234-5-5-5V61.078c0-2.656-1.047-5.203-2.922-7.078L94 41.922A10 10 0 0 0 86.922 39H79v-7.5c0-4.14-3.36-7.5-7.5-7.5zM99 61.078V64H79V49h7.922zM39 81.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M81.5 89a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0"
    }, null, -1)
  ])))
}
export default { render: render }